import React, { memo } from "react";
import { Typography, FormHelperText, Link } from "@mui/material";
import { useField } from "formik";

import RpMuiSwitch from "@/components/muiCustom/switch/RpMuiSwitch";
import RRDDirectMailToolTips from "../RRDDirectMailToolTips";

const addressHelperSx = { color: "var(--neutral-700)" };
const FeedbackLink = Link as React.ElementType;

function RRDDirectStoreCopyToggleInput({
  name,
  disabled = false,
  address = "",
  onOpenFeedback,
}) {
  const [storeCopyField] = useField(name);

  return (
    <>
      <Typography variant="body2" gutterBottom fontWeight={600}>
        Store Copy (Y/N) <RRDDirectMailToolTips type="store_copy" />
      </Typography>
      <RpMuiSwitch
        {...storeCopyField}
        checked={storeCopyField.value}
        disabled={disabled}
      />
      {address && (
        <>
          <FormHelperText sx={addressHelperSx}>
            <strong>Address:</strong> {address}
          </FormHelperText>
          {typeof onOpenFeedback === "function" && (
            <FormHelperText
              sx={addressHelperSx}
              className="mt-2 fw-sb"
              disabled
            >
              Not your store&apos;s address?{" "}
              <FeedbackLink
                component="button"
                variant="p"
                onClick={(e) => {
                  e.preventDefault();
                  onOpenFeedback();
                }}
                className="fw-sb mb-1"
                sx={{
                  color: "var(--primary-base)",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                Click here
              </FeedbackLink>
            </FormHelperText>
          )}
        </>
      )}
    </>
  );
}

export default memo(RRDDirectStoreCopyToggleInput);
